import Badge from 'react-bootstrap/Badge';

function AppBadge({ children, variant = 'purple', style, ...props }) {
  const styles = {
    purple: {
      backgroundColor: 'var(--color-purple-ghost)',
      color: 'var(--color-purple-primary)',
      border: '1px solid var(--color-purple-mid)',
    },
    amber: {
      backgroundColor: 'var(--color-amber-ghost)',
      color: 'var(--color-neutral)',
      border: '1px solid var(--color-amber-mid)',
    },
  };

  return (
    <Badge
      bg=""
      // `style` some à parte e por último: espalhado junto com o resto de
      // `props`, ele substituiria o objeto inteiro (fundo, cor, borda) em vez
      // de só ajustar o que o chamador pediu — foi assim que um `style={{
      // flexShrink: 0 }}` apagou a cor do badge de contagem de produtos.
      style={{ ...styles[variant], borderRadius: 'var(--radius-sm)', padding: '4px 8px', fontWeight: 500, ...style }}
      {...props}
    >
      {children}
    </Badge>
  );
}

export default AppBadge;
